import { AnyAction } from 'redux';
import {
  App,
  determineLaufzeit,
  getVetragsOptionenFromVorvertrag,
  ThhHundVorbelegungdaten,
  Vertragsoptionen,
} from '@ps20-frontend/frontend-models';
import { GlobalActions, TARIF_CHECKED } from '@ps20-frontend/shop-integration-redux';
import { addVorvertragToAngeboteReducer, vertragsoptionenReducer } from '@ps20-frontend/reducers';
import { Selbstbeteiligung } from '@ps20/bff-models';
import { IAppState } from '../appState';
import { ThhHundActions } from '../thhHundActions';

export const thhHundVertragsoptionenReducer = function (
  sectionState: Vertragsoptionen = null,
  action: AnyAction,
  state: IAppState,
): Vertragsoptionen {
  sectionState = vertragsoptionenReducer(sectionState, action, App.THH_HUND, state);
  switch (action.type) {
    case ThhHundActions.SELBSTBETEILIGUNG_CHANGED: {
      const selbstbeteiligung: Selbstbeteiligung = action.payload;
      return { ...sectionState, selbstbeteiligung };
    }
    case TARIF_CHECKED: {
      const newState: Vertragsoptionen = { ...sectionState };
      determineLaufzeit(action, newState, state.produkt, sectionState);
      return newState;
    }
    case ThhHundActions.VERSICHERUNGSSUMME_CHANGED: {
      const newState: Vertragsoptionen = { ...sectionState };
      newState.versicherungssumme = action.payload.versSummeLeistung;
      return newState;
    }
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      return addVorvertragToAngeboteReducer(sectionState, action, App.THH_HUND);
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: ThhHundVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.THH_HUND) {
        const newState: Vertragsoptionen = getVetragsOptionenFromVorvertrag(
          sectionState,
          actionPayload,
        );
        return { ...newState };
      }
      return sectionState;
    }
    case GlobalActions.THH_HUND_VORBELEGUNG_FINISHED: {
      const actionPayload: ThhHundVorbelegungdaten = action.payload.vorhandeneVorbelegungdaten;
      return { ...sectionState, urbeginn: actionPayload.urbeginn };
    }
    default:
      return sectionState;
  }
};
